export enum IdeaAlertType {
  Info = 'Info',
  Error = 'Error',
  Warning = 'Warning',
}

export enum IdeaDirectionType {
  Long = 'Long',
  Short = 'Short',
}
